
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.44667 4.74671C8.41494 4.66487 8.36736 4.59011 8.30666 4.52671L4.97333 1.19338C4.91117 1.13122 4.83738 1.08191 4.75617 1.04827C4.67495 1.01463 4.58791 0.997314 4.5 0.997314C4.32246 0.997314 4.1522 1.06784 4.02667 1.19338C3.96451 1.25553 3.9152 1.32933 3.88156 1.41054C3.84792 1.49176 3.83061 1.5788 3.83061 1.66671C3.83061 1.84424 3.90113 2.01451 4.02667 2.14004L6.22667 4.33338H1.16667C0.989856 4.33338 0.820286 4.40361 0.695262 4.52864C0.570238 4.65366 0.5 4.82323 0.5 5.00004C0.5 5.17685 0.570238 5.34642 0.695262 5.47145C0.820286 5.59647 0.989856 5.66671 1.16667 5.66671H6.22667L4.02667 7.86004C3.96418 7.92202 3.91458 7.99575 3.88074 8.07699C3.84689 8.15823 3.82947 8.24537 3.82947 8.33337C3.82947 8.42138 3.84689 8.50852 3.88074 8.58976C3.91458 8.671 3.96418 8.74473 4.02667 8.80671C4.08864 8.86919 4.16238 8.91879 4.24361 8.95264C4.32485 8.98648 4.41199 9.00391 4.5 9.00391C4.58801 9.00391 4.67514 8.98648 4.75638 8.95264C4.83762 8.91879 4.91136 8.86919 4.97333 8.80671L8.30666 5.47337C8.36736 5.40997 8.41494 5.33521 8.44667 5.25338C8.51334 5.09107 8.51334 4.90902 8.44667 4.74671Z","fill":"#161A21"}})])
          )
        }
      }
    